import {
    getObjVal,
    _for,
} from 'tools';
const invoice = {
    state: {
        invoiceExpressBean: {
            expressCompanyName: null, // 快递公司
            expressNO: null,  // 快递单号
            expressPayType: null,  // 运费支付
        },

        invoiceInfoBean: {
            amount: null, // 发票金额
            taxpaerType: null, // 纳税人类型
            taxBankId: null, // 税务开户银行账号
            taxBankName: null, // 税务开户银行名称
            taxId: null, // 纳税人识别号
            taxName: null, // 纳税人名称
            title: null, // 发票抬头
            taxAddress: null, // 税务登记地址
            taxTel: null, // 税务联系电话
            policySn: null, // 保单号
            orderType: null, // 1:原单 2:保全
        },

        invoiceMaterialBean: {
            emailAddress: null, // 获取资料的邮箱
            materialInfo: null // 资料信息
        },

        invoiceReceiveBean: {
            provinceCode: null,
            cityCode: null,
            districtCode: null,
            provinceName: null,
            cityName: null,
            districtName: null,
            receiveAddress: null, // 收件地址
            receiveEmail: null, // 电子邮箱
            receiveMobile: null, // 联系电话
            receiveName: null, // 收件人
        },

        invoiceType: 1, // 1:普票 2:专票
        policyType: 1, //  1:电子发票 2:纸质发票
        // orderType: 1, // 1:新单 2:保全
        policyUuid: null,
        id: null,

        invoiceStatus: null,
        createTime: null,
        showSpecialInvoice: null,
        failMsg: null,
        needMaterial: false, // 专票是否需要上传资料
        middleStatus: 200, // 专票申请中的状态值

        productId: '',
    },
    getters: {
        productId(state) {
            return state.productId
        },
        invoiceExpressBean(state) {
            return state.invoiceExpressBean
        },
        invoiceInfoBean(state) {
            return state.invoiceInfoBean
        },
        invoiceMaterialBean(state) {
            return state.invoiceMaterialBean
        },
        invoiceReceiveBean(state) {
            return state.invoiceReceiveBean
        },
        invoiceType(state) {
            return state.invoiceType
        },
        policyType(state) {
            return state.policyType
        },
        submitInvoice(state) {
            let invoiceMaterialBean = JSON.parse(JSON.stringify(state.invoiceMaterialBean))
            if (state.invoiceType == 1 || !state.needMaterial) {
                delete invoiceMaterialBean.materialInfo
            }
            return {
                // invoiceExpressBean: state.invoiceExpressBean,
                invoiceInfoBean: state.invoiceInfoBean,
                invoiceMaterialBean: invoiceMaterialBean,
                invoiceReceiveBean: state.invoiceReceiveBean,
                invoiceType: state.invoiceType,
                policyType: state.policyType,
                policyUuid: state.policyUuid,
                id: state.id,
                orderType: state.orderType,
            }
        },
        submitInvoiceChangeStatus(state) {
            return {
                // invoiceExpressBean: state.invoiceExpressBean,
                invoiceInfoBean: state.invoiceInfoBean,
                invoiceMaterialBean: state.invoiceMaterialBean,
                invoiceReceiveBean: state.invoiceReceiveBean,
                invoiceType: state.invoiceType,
                policyType: state.policyType,
                policyUuid: state.policyUuid,
                id: state.id,
                orderType: state.orderType,
                invoiceStatus: state.middleStatus
            }
        },
        invoiceStatus(state) {
            return state.invoiceStatus
        },
        createTime(state) {
            return state.createTime
        },
        showSpecialInvoice(state) {
            return state.showSpecialInvoice
        },
        failMsg(state) {
            return state.failMsg
        },
        policyUuid(state) {
            return state.policyUuid
        },
        needMaterial(state) {
            return state.needMaterial
        },
        middleStatus(state) {
            return state.middleStatus
        }
    },
    mutations: {
        resetInvoice(state) {
            state.invoiceExpressBean.expressCompanyName = null
            state.invoiceExpressBean.expressNO = null
            state.invoiceExpressBean.expressPayType = null

            state.invoiceInfoBean.amount = null
            state.invoiceInfoBean.taxBankId = null
            state.invoiceInfoBean.taxBankName = null
            state.invoiceInfoBean.taxId = null
            state.invoiceInfoBean.taxName = null
            state.invoiceInfoBean.taxpaerType = null
            state.invoiceInfoBean.title = null
            state.invoiceInfoBean.taxAddress = null
            state.invoiceInfoBean.taxTel = null
            state.invoiceInfoBean.policySn = null
            state.invoiceInfoBean.orderType = null

            state.invoiceMaterialBean.emailAddress = null
            state.invoiceMaterialBean.materialInfo = null // 资料信息

            state.invoiceReceiveBean.provinceCode = null
            state.invoiceReceiveBean.cityCode = null
            state.invoiceReceiveBean.districtCode = null
            state.invoiceReceiveBean.provinceName = null
            state.invoiceReceiveBean.cityName = null
            state.invoiceReceiveBean.districtName = null
            state.invoiceReceiveBean.receiveAddress = null
            state.invoiceReceiveBean.receiveEmail = null
            state.invoiceReceiveBean.receiveMobile = null
            state.invoiceReceiveBean.receiveName = null

            state.invoiceType = 1
            state.policyType = 1
            state.policyUuid = null
            state.id = null
            state.invoiceStatus = null
            state.createTime = null
            state.showSpecialInvoice = null
            state.failMsg = null
            state.needMaterial = false
        },
        saveInvoiceAttr(state, data) {
            if (data && data.key) {
                let keyArr = data.key.split('.')
                if (keyArr.length == 1) {
                    state[keyArr[0]] = data.value
                } else if (keyArr.length == 2) {
                    state[keyArr[0]][keyArr[1]] = data.value
                } else {
                    console.log('保存失败')
                }

                switch (data.key){
                  case 'invoiceInfoBean.taxId':
                      state[keyArr[0]][keyArr[1]] = data.value.toUpperCase()
                      break;
                }
            }
        },
        setAddress(state, data) {
            state.invoiceReceiveBean.provinceCode = data.province.code
            state.invoiceReceiveBean.provinceName = data.province.name
            state.invoiceReceiveBean.cityCode = data.city.code
            state.invoiceReceiveBean.cityName = data.city.name
            state.invoiceReceiveBean.districtCode = data.area.code
            state.invoiceReceiveBean.districtName = data.area.name
        },
        setInvoiceData(state, data) {
            state.policyUuid = data.policyUuid
            state.policyType = data.policyType
            state.showSpecialInvoice = data.showSpecialInvoice
            state.invoiceInfoBean.title = data.groupName
            state.invoiceInfoBean.taxName = data.groupName
            // state.invoiceInfoBean.taxpaerType = data.taxpaerType
            state.invoiceInfoBean.amount = data.mergeInvoiceAmount || data.totalPremium
            state.invoiceInfoBean.taxId = data.groupInvoiceInfoAssist ? data.groupInvoiceInfoAssist.taxId : ''
            state.invoiceInfoBean.policySn = data.policySn
            state.productId = data.productId

            if (data.materialInfo && data.materialInfo.materialInfo) {
                for (let item of data.materialInfo.materialInfo) {
                    item.fileUrlList = []
                }
                state.needMaterial = true
                state.invoiceMaterialBean.materialInfo = data.materialInfo.materialInfo
            }
            // 新增历史发票信息回塞
            const groupInvoiceInfoAssist = getObjVal(data, 'groupInvoiceInfoAssist');
            if(groupInvoiceInfoAssist){
                _for(groupInvoiceInfoAssist, (el, key) => {
                    state.invoiceInfoBean[key] = el
                });
            };

            if (data.groupInvoiceInfo) {
                state.invoiceInfoBean.orderType = data.groupInvoiceInfo.orderType
                state.policyType = data.groupInvoiceInfo.policyType !== undefined ? data.groupInvoiceInfo.policyType: state.policyType
                state.invoiceType = data.groupInvoiceInfo.invoiceType
                state.invoiceStatus = data.groupInvoiceInfo.invoiceStatus
                state.createTime = data.groupInvoiceInfo.createTime
                state.id = data.groupInvoiceInfo.id
                state.failMsg = data.groupInvoiceInfo.failMsg
                state.policyUuid = data.groupInvoiceInfo.policyUuid

                let invoiceInfo = JSON.parse(data.groupInvoiceInfo.invoiceInfo || '{}')
                let receiveInfo = JSON.parse(data.groupInvoiceInfo.receiveInfo || '{}')
                let specialInvoiceMaterial = JSON.parse(data.groupInvoiceInfo.specialInvoiceMaterial || '{}')
                let expressInfo = JSON.parse(data.groupInvoiceInfo.expressInfo || '{}')

                for (let key in invoiceInfo) {
                    state.invoiceInfoBean[key] = invoiceInfo[key]
                }
                for (let key in receiveInfo) {
                    state.invoiceReceiveBean[key] = receiveInfo[key]
                }

                if (state.needMaterial) {
                    for (let key in specialInvoiceMaterial) {
                        if (key == 'materialInfo') {
                            let list = specialInvoiceMaterial.materialInfo
                            for (let material of state.invoiceMaterialBean.materialInfo) {
                                let item = list.filter(item => {
                                    return item.type == material.type
                                })[0]
                                if (item) {
                                    material.fileUrlList = item.fileUrlList || []
                                }
                            }
                        } else {
                            state.invoiceMaterialBean[key] = specialInvoiceMaterial[key]
                        }
                    }
                } else { //专票邮箱
                  state.invoiceMaterialBean.emailAddress = specialInvoiceMaterial.emailAddress
                }

                for (let key in expressInfo) {
                    state.invoiceExpressBean[key] = expressInfo[key]
                }
            }
        },
        setMaterialInfo(state, data) {
            state.invoiceMaterialBean.materialInfo[data.index].fileUrlList = data.list
        },
        initMaterialInfo(state, data) {
            state.invoiceMaterialBean.materialInfo = data
        }
    },
    actions: {

    },
}

export default invoice



// WEBPACK FOOTER //
// ./src/store/modules/invoice.js